import { InjectionToken } from '@angular/core';

export interface ShuiModalConfig<TData = unknown> {
    data?: TData;
    width?: string;
    title?: string;
    sticky?: boolean;
}

export const SHUI_MODAL_CONFIG = new InjectionToken<ShuiModalConfig>('SHUI_MODAL_CONFIG');
